import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { determineIfUserHasAccessToResource } from '../../HelperMethods/UserUtilities';
import { ENTITY_ACCESS_TYPE, RESOURCE_TYPE, RESOURCES } from '../../HelperMethods/role-resource-constants';
import { crossLightSVGNew, publishLightSVG, draftLightSVG } from '../../common/constants';

const imgStyle = {
  width: '24px',
  height: '24px',
  margin: 0,
  maxHeight: 'none',
  maxWidth: 'none',
};

const buttonStyle = {
  background: '#424f62',
  border: '1px solid #4c4c4c',
  padding: '2px',
  marginRight: '5px',
  marginTop: 0,
};

const PublishButtonGroup = React.memo(function PublishButtonGroup({
  onPublish,
  onDiscardPublish,
  isSchedulerView,
  showOnlyPublishButton = false,
}) {
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);
  const settings = useSelector((state) => state.appReducer.settings);
  const packagesInfo = useSelector((state) => state.appReducer.packagesInfo);
  const shouldShowPublishButton = useMemo(
    () =>
      determineIfUserHasAccessToResource({
        resourceType: RESOURCE_TYPE.FEATURE,
        resource: RESOURCES.FEATURE.ROUTING_ENGINE,
        user: loggedInUser,
        packageName: settings?.package,
        packagesInfo,
      }) ||
      determineIfUserHasAccessToResource({
        resourceType: RESOURCE_TYPE.FEATURE,
        resource: RESOURCES.FEATURE.PLANNING_ENGINE,
        user: loggedInUser,
        packageName: settings?.package,
        packagesInfo,
      }) ||
      determineIfUserHasAccessToResource({
        resourceType: RESOURCE_TYPE.ENTITY,
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        user: loggedInUser,
        packageName: settings?.package,
        packagesInfo,
      }),
    [loggedInUser]
  );
  if (!shouldShowPublishButton) return null;
  return (
    <>
      {!showOnlyPublishButton && (
        <>
          {' '}
          <Button onClick={onDiscardPublish} style={buttonStyle} className="header-item">
            <img
              src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(crossLightSVGNew)}`}
              alt="Discard"
              style={imgStyle}
            />
            <div className="item-label">Discard</div>
          </Button>
          {isSchedulerView &&
            determineIfUserHasAccessToResource({
              resourceType: RESOURCE_TYPE.FEATURE,
              resource: RESOURCES.FEATURE.SAVE_AS_DRAFT,
              user: loggedInUser,
              packageName: settings?.package,
              packagesInfo,
            }) && (
              <Button
                onClick={() => {
                  onPublish(true, true);
                }}
                style={buttonStyle}
                className="header-item"
              >
                <img
                  src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(draftLightSVG)}`}
                  alt="Discard"
                  style={imgStyle}
                />
                <div className="item-label">Save as Draft</div>
              </Button>
            )}
        </>
      )}

      {/* <Button
        onClick={() => onPublish(false)}
        style={{ background: '#424f62', border: '1px solid #4c4c4c', padding: '8px 11px' }}
      >
        <img
          src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(arrowUpLightSVG)}`}
          alt="Publish"
          style={{ width: '8px', height: '8px' }}
        />
        <div className="item-label">Publish</div>
      </Button> */}
      <Button onClick={() => onPublish(true)} style={buttonStyle} className="header-item">
        <img
          src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(publishLightSVG)}`}
          alt="Publish as Planned"
          style={imgStyle}
        />
        <div className="item-label">Publish</div>
      </Button>
    </>
  );
});

PublishButtonGroup.propTypes = {
  onPublish: PropTypes.func.isRequired,
  onDiscardPublish: PropTypes.func.isRequired,
  isSchedulerView: PropTypes.bool.isRequired,
  showOnlyPublishButton: PropTypes.bool,
};

export default PublishButtonGroup;
